import ViewProfileContainer from './ViewProfileContainer';

export default ViewProfileContainer